<template>
  <div class="content" @scroll="handleScroll">
    <div class="search">
      <a-input-search allowClear v-model="searchData.keyword" :placeholder="$t('message.search.placeholder')" @change="onSearch">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="searchData.keyword" slot="suffix" @click="searchData.keyword = undefined, onSearch()" :src="require('@/assets/icons/icon_gb.png')" />
        <a-button class="search-btn" slot="enterButton">
          {{ $t('message.search.search') }}
        </a-button>
      </a-input-search>
      <a-range-picker @change="onChange" v-model="time">
        <img slot="suffixIcon" :src="require('@/assets/icons/icon_rq@2x.png')" />
      </a-range-picker>
    </div>
    <div>
      <a-tabs v-model="type" @change="callback" class="tab">
        <a-tab-pane
          key="feedback"
          :tab="ideaNum === 0 ? $t('message.tabs.feedback.title') : $t('message.tabs.feedback.titleWithCount', { count: ideaNum })"
        >
          <List type="feedback" ref="feedback" @getSearchData="getSearchData" :hasUnRead="ideaNum !== 0"></List>
        </a-tab-pane>
        <a-tab-pane
          key="message"
          :tab="resourceNum === 0 ? $t('message.tabs.resource.title') : $t('message.tabs.resource.titleWithCount', { count: resourceNum })"
          force-render
        >
          <List type="message" ref="message" @getSearchData="getSearchData" :hasUnRead="resourceNum !== 0"></List>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import List from './list.vue'
import { unReadCountGet } from '@/api/message.js'

export default {
  components: {
    List
  },
  data() {
    return {
      searchData: {},
      ideaNum: 0,
      resourceNum: 0,
      time: [],
      type: 'feedback'
    }
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // 监听路由
    $route(to, from) {
      if (to.name === 'messageIndex') {
        this.getUnReadCount()
      }
    }
  },
  methods: {
    onSearch() {
      this.$refs[this.type].resetList()
    },
    onChange(date, dateString) {
      this.time = date
      if (this.time.length > 1) {
        this.searchData.startTime = this.time[0].format('YYYY-MM-DD')
        this.searchData.endTime = this.time[1].format('YYYY-MM-DD')
      } else {
        this.searchData.startTime = ''
        this.searchData.endTime = ''
      }
      this.onSearch()
    },
    callback(key) {
      this.getUnReadCount()
      this.searchData = {}
      this.time = []
      this.$refs[this.type].resetList()
    },
    async getUnReadCount() {
      const res = await unReadCountGet()
      if (res.code == 200) {
        this.ideaNum = res.data.child.find(item => item.type === '意见反馈').count
        this.resourceNum = res.data.child.find(item => item.type === '资源通知').count
        this.$store.commit('setUnReadCount', res.data.totalCount > 99 ? '99+' : res.data.totalCount)
      }
    },
    getSearchData(callback) {
      callback(this.searchData)
    },
    handleScroll(event) {
      const element = event.target
      if (element.scrollTop + element.clientHeight >= element.scrollHeight) {
        // alert('已经滚动到底部！')
        this.$refs[this.type].next()
      }
    }
  },
  mounted () {
    this.getUnReadCount()
  }
}

</script>

<style scoped lang="less">
.content{
  padding: 46px 20px;
}
.search{
  display: flex;
  align-items: center;
  /deep/.ant-input-group-wrapper{
    width: 330px;
    height: 35px;
    position: relative;
    overflow: hidden;
    .ant-input-prefix{
      // right: auto;
      left: 16px;
      img{
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 69px;
      .anticon.anticon-close-circle.ant-input-clear-icon{
        display: none;
      }
      .clear{
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search{
      width: 100%;
      height: 35px;
      .ant-input{
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-radius: 20px;
        box-shadow: none;
        border: 1px solid #D8DCE0;
        &:focus{
          border-color: #ffb829;
          box-shadow: 0 0 0 2px rgba(255, 160, 0, 0.2);
        }
      }
    }
    .ant-input-group-addon {
      position: absolute;
      right: 63px;
      top: 0;
      border-radius: 20px;
      z-index: 2;
      background: none;
      .search-btn{
        border-left: 0;
        height: 35px;
        border-color: rgba(0, 0, 0, 0);
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background: none;
        padding-right: 109px;
        &::after{
          content: none;
        }
        span{
          display: flex;
          font-size: 14px;
          color: #333333;
          position: relative;
          align-items: center;
          &::before{
            left: -8px;
            content: '';
            width: 1px;
            height: 15px;
            background: #E9E9E9;
            position: absolute;
          }
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  /deep/.ant-calendar-picker{
    width: 230px;
    margin-left: 22px;
    .ant-calendar-picker-input.ant-input{
      height: 35px;
      color: #000;
      border-radius: 20px;
      box-shadow: none;
      border: 1px solid #D8DCE0;
    }
  }
}
/deep/ .tab{
  margin-top: 27px;
  .ant-tabs-bar{
    border-bottom: 1px solid #ededed;
  }
  .ant-tabs-nav .ant-tabs-tab{
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    &::before{
      display: none;
    }
  }
  .ant-tabs-nav .ant-tabs-tab-active{
    color: #FF5F00;
    position: relative;
    font-weight: 500;
    &::before{
      content: '';
      position: absolute;
      bottom: 0;
      top: auto;
      display: block;
      width: 24px;
      height: 4px;
      background: #FF6D00;
      border-radius: 3px;
      left: 50%;
      margin-left: -12px;
    }
  }
  .ant-tabs-ink-bar{
    display: none !important;
  }
  .ant-tabs-bar{
    margin: 0;
  }
}
</style>
